import { queryOptions } from '@tanstack/react-query'
import { getAgreement } from 'Royalty/api/AgreementApi'

import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

export const agreementQueries = {
    all: () => ['agreements'],
    details: () => [...agreementQueries.all(), 'detail'],
    detail: (id: number) =>
        queryOptions({
            queryKey: [...agreementQueries.details(), id],
            queryFn: () => getAgreement(id),
            staleTime: RequestStaleTime.default,
        }),
}
